import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import HeroSection from "../theme/HeroSection";
import HomePageBody from "./HomePageBody";

const HERO_IMAGE = "/images/Boys+Basketball.png";

const HomeSmsp: React.FC = () => {
    const scrollToRoles = () => {
        const element = document.getElementById("select-your-role");
        if (element) element.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <Box>
            <HeroSection imageUrl={HERO_IMAGE} minHeight="80vh" showWave={true}>
                <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                    <Box sx={{ maxWidth: 640 }}>
                        <Typography
                            variant="h3"
                            component="h1"
                            sx={{
                                color: "white",
                                fontWeight: "bold",
                                mb: 2,
                                fontSize: { xs: "1.75rem", sm: "2rem", md: "2.25rem" }
                            }}
                        >
                            Confidence Isn't a Trait. It's a System.
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                color: "rgba(255,255,255,0.95)",
                                mb: 3,
                                lineHeight: 1.5
                            }}
                        >
                            Strong Mind Strong Performance is a mental strengthening program designed for youth athletes ages 13–18. Our proven system transforms anxiety into confidence and inconsistency into peak performance.
                        </Typography>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={scrollToRoles}
                            data-attr="home-smsp_explore-path"
                            endIcon={<ChevronRightIcon />}
                            sx={{
                                px: 3,
                                py: 1.5,
                                fontWeight: "bold",
                                fontSize: "1rem"
                            }}
                        >
                            Explore your path
                        </Button>
                    </Box>
                </Container>
            </HeroSection>
            <HomePageBody />
        </Box>
    );
};

export default HomeSmsp;
